import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { partida } from '../models/articulos/alta-articulo'; 

@Injectable({
  providedIn: 'root'
})
export class PartidasService {

  private API = 'http://172.16.1.50:3010';

  constructor(private http: HttpClient) { }

  listarPartidas(){
    return this.http.get<{ok: boolean; partidas: partida[]}>(`${this.API}/partidas`);
  }
}